import { useAtom } from 'jotai';
import { useState } from 'react';
import {
  disableBackgroundColorAtom,
  hideDropZoneIconsAtom,
  hideDropZoneTextAtom,
  hideStepInfoAtom,
  isCompactAtom,
} from '../atoms';

export const useSettingsCanvas = () => {
  const [disableBackgroundColor, setDisableBackgroundColor] = useAtom(
    disableBackgroundColorAtom
  );
  const [isCompact, setIsCompact] = useAtom(isCompactAtom);
  const [hideStep, setHideStep] = useAtom(hideStepInfoAtom);
  const [hideDropZoneIcons, setHideDropZoneIcons] = useAtom(
    hideDropZoneIconsAtom
  );
  const [hideDropZoneText, setHideDropZoneText] = useAtom(hideDropZoneTextAtom);
  const [isMousePressed, setIsMousePressed] = useState(false);

  const toggleBackgroundColor = () => {
    setDisableBackgroundColor(!disableBackgroundColor);
  };

  const toggleCompact = () => {
    setIsCompact(!isCompact);
  };

  const toggleDropZoneIcons = () => {
    setHideDropZoneIcons(!hideDropZoneIcons);
  };

  const toggleDropZoneText = () => {
    setHideDropZoneText(!hideDropZoneText);
  };

  const toggleHideStep = () => {
    setHideStep(!hideStep);
  };

  const handleMouseDown = () => {
    setIsMousePressed(true);
  };

  const handleMouseUp = () => {
    setIsMousePressed(false);
  };

  return {
    disableBackgroundColor,
    handleMouseDown,
    handleMouseUp,
    hideDropZoneIcons,
    hideDropZoneText,
    hideStep,
    isCompact,
    isMousePressed,
    setDisableBackgroundColor,
    setHideDropZoneIcons,
    setHideDropZoneText,
    setIsCompact,
    toggleBackgroundColor,
    toggleCompact,
    toggleDropZoneIcons,
    toggleDropZoneText,
    toggleHideStep,
  };
};
